// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.strip-grey-bg {
  background: #E7E7E7;
  width: 100%;
  margin-bottom: 10px;
}
.strip-grey-bg p {
  font-size: 20px !important;
  font-weight: bold;
}
.strip-grey-bg h2 {
  font-family: var(--font-primary) !important;
}

.sub-heading {
  font-weight: bold;
  font-size: 38px;
}

ion-grid {
  margin: 15px 0px !important;
}

.reward-bar-container {
  height: 20px;
  margin: 0 10px;
}
.reward-bar-container .reward-bar-background {
  width: 100%;
  background-color: #c0bbbb;
  border-radius: 12px;
}
.reward-bar-container .reward-bar-background-desktop {
  width: 100%;
  background-color: #c0bbbb;
  border-radius: 12px;
}
.reward-bar-container .reward-bar {
  width: 0%;
  height: 20px;
  background-color: #3f0202;
  border: solid 10px transparent;
  border-radius: 25px;
}
.reward-bar-container .empty-reward-bar {
  width: 0%;
  height: 20px;
  background-color: #c0bbbb;
  border: solid 10px transparent;
  border-radius: 25px;
}
.reward-bar-container .reward-bar-label {
  position: relative;
  font-size: x-large;
  font-weight: bold;
  top: -36px;
  color: #000000;
  width: 100%;
  line-height: 36px;
  text-align: center;
}

.loyalty-tier-box {
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.loyalty-tier-box .individual-loyalty {
  font-size: 0.7rem;
  padding: 20px;
}
@media (max-width: 800px) {
  .loyalty-tier-box {
    flex-direction: column;
  }
}

.credits {
  color: rgb(105, 11, 11);
}

.loyalty-card-superbox {
  width: 40%;
  transform: translateX(75%);
}

.loyalty-card-box img {
  position: relative;
  width: 100%;
}

.loyalty-card-box p.loyalty-card-name-text {
  position: absolute;
  bottom: 5%;
  left: 7%;
  color: var(--ion-color-light);
  font-weight: bold;
  font-size: 1rem;
}

@media screen and (max-width: 550px) {
  .loyalty-card-superbox {
    width: 75%;
    transform: translateX(15%);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/boyd-rewards/boyd-my-balance/boyd-my-balance.component.scss"],"names":[],"mappings":"AAAA;EAUI,mBAAA;EAEA,WAAA;EACA,mBAAA;AATJ;AAHI;EACI,0BAAA;EACA,iBAAA;AAKR;AAFI;EACI,2CAAA;AAIR;;AAKA;EACI,iBAAA;EACA,eAAA;AAFJ;;AAKA;EACI,2BAAA;AAFJ;;AAKA;EACI,YAAA;EACA,cAAA;AAFJ;AAII;EACI,WAAA;EACA,yBAAA;EACA,mBAAA;AAFR;AAKI;EACI,WAAA;EACA,yBAAA;EACA,mBAAA;AAHR;AAMI;EACI,SAAA;EACA,YAAA;EACA,yBAAA;EACA,8BAAA;EACA,mBAAA;AAJR;AAOI;EACI,SAAA;EACA,YAAA;EACA,yBAAA;EACA,8BAAA;EACA,mBAAA;AALR;AAQI;EACI,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,cAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;AANR;;AAUA;EACI,gBAAA;EAKA,aAAA;EACA,mBAAA;EACA,6BAAA;AAXJ;AAKI;EACI,iBAAA;EACA,aAAA;AAHR;AAQI;EATJ;IAUQ,sBAAA;EALN;AACF;;AAOA;EACI,uBAAA;AAJJ;;AAQA;EACG,UAAA;EACK,0BAAA;AALR;;AAQI;EACI,kBAAA;EACA,WAAA;AALR;;AAQI;EACI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,6BAAA;EACA,iBAAA;EACA,eAAA;AALR;;AAQI;EACI;IACI,UAAA;IACA,0BAAA;EALV;AACF","sourcesContent":[".strip-grey-bg {\r\n    p {\r\n        font-size: 20px !important;\r\n        font-weight: bold;\r\n    }\r\n\r\n    h2 {\r\n        font-family: var(--font-primary) !important;\r\n    }\r\n\r\n    background: #E7E7E7;\r\n    // background: radial-gradient(circle, rgba(179, 179, 185, 1) 0%, rgba(232, 232, 232, 1) 51%, rgba(179, 179, 185, 1) 100%);\r\n    width: 100%;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.sub-heading {\r\n    font-weight: bold;\r\n    font-size: 38px;\r\n}\r\n\r\nion-grid {\r\n    margin: 15px 0px !important;\r\n}\r\n\r\n.reward-bar-container {\r\n    height: 20px;\r\n    margin: 0 10px;\r\n\r\n    .reward-bar-background {\r\n        width: 100%;\r\n        background-color: #c0bbbb;\r\n        border-radius: 12px;\r\n    }\r\n\r\n    .reward-bar-background-desktop {\r\n        width: 100%;\r\n        background-color: #c0bbbb;\r\n        border-radius: 12px;\r\n    }\r\n\r\n    .reward-bar {\r\n        width: 00%;\r\n        height: 20px;\r\n        background-color: #3f0202;\r\n        border: solid 10px transparent;\r\n        border-radius: 25px;\r\n    }\r\n\r\n    .empty-reward-bar {\r\n        width: 00%;\r\n        height: 20px;\r\n        background-color: #c0bbbb;\r\n        border: solid 10px transparent;\r\n        border-radius: 25px;\r\n    }\r\n\r\n    .reward-bar-label {\r\n        position: relative;\r\n        font-size: x-large;\r\n        font-weight: bold;\r\n        top: -36px;\r\n        color: #000000;\r\n        width: 100%;\r\n        line-height: 36px;\r\n        text-align: center;\r\n    }\r\n\r\n}\r\n.loyalty-tier-box{\r\n    margin-top: 10px;\r\n    .individual-loyalty{\r\n        font-size: 0.70rem;\r\n        padding: 20px;\r\n    }\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-around;\r\n    @media (max-width: 800px) {\r\n        flex-direction: column;\r\n      }\r\n}\r\n.credits {\r\n    color: rgb(105, 11, 11)\r\n}\r\n\r\n\r\n.loyalty-card-superbox{\r\n   width: 40%;\r\n        transform: translateX(75%);\r\n    }\r\n    \r\n    .loyalty-card-box img{\r\n        position: relative;\r\n        width: 100%;\r\n    }\r\n    \r\n    .loyalty-card-box p.loyalty-card-name-text{\r\n        position: absolute;\r\n        bottom: 5%;\r\n        left: 7%;\r\n        color: var(--ion-color-light);\r\n        font-weight: bold;\r\n        font-size: 1rem;\r\n    }\r\n    \r\n    @media screen and (max-width:550px) {\r\n        .loyalty-card-superbox{\r\n            width: 75%;\r\n            transform: translateX(15%);\r\n     }\r\n\r\n    }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
